import { queryKeys } from '@/lib/query-keys';
import { operatorClient } from '@/lib/api/ts-rest';
import type { Operator } from '@octave/contracts';
import { useQuery } from '@tanstack/react-query';

export const useOperators = () => {
  return useQuery<Operator[], Error>({
    queryKey: queryKeys.catalog.operators(),
    queryFn: async () => {
      const res = await operatorClient.listOperators();
      if (res.status !== 200) throw new Error('Failed to load operators');
      return res.body;
    },
  });
};
